import ProductDetailsMain from "components/pages/product-details";
export default function ProductDetails() {
  return <ProductDetailsMain />;
}
